import React, { Component } from 'react';
import store from './store'
import { Provider } from 'react-redux'

import LoadingBar from './views/loadingbar/container'

import { Snackbar } from 'react-redux-snackbar';

import Administrativo from './views/administrativo/container'
import Login from './views/login/container'
import Web from './views/website/component'

import { BrowserRouter as Router, Route, Link , Switch} from "react-router-dom";


import "./style.css"

window.store = store;


class App extends Component {
  

  render() {


    return (
      <Provider store={store}> 
        <Router>
          <div className="App">
            <LoadingBar/>
            <Switch>
              <Route path="/adm" component={Administrativo} />
              <Route path="/login" component={Login} />
              <Route path='/' component={Web}/>
            </Switch>
            <Snackbar/>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js